module.exports = "<ng-template #modal let-modal>\n  <ng-content></ng-content>\n</ng-template>\n"